import { Button, Modal } from 'rsuite';
import React, { useEffect, useState } from 'react';
import Styles from './styles.js';
import Carousel from 'react-elastic-carousel';
import PropTypes from 'prop-types';
function JuctionModal({ show, setClose }) {
  const [width, setWidth] = useState(null);
  const [no, setNo] = useState(1);
  const [loading] = useState(false);
  const [items, setItems] = useState([
    { id: 1, imgsrc: '/static/images/landingPages/TheJuction/triangle.png' },
    { id: 2, imgsrc: '/static/images/landingPages/TheJuction/timeshedule.png' },
  ]);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Modal
      backdrop={true}
      className="xxs-size juctionModal"
      size={width <= 600 ? 'xs' : width <= 820 ? 'md' : 'lg'}
      // size="lg"
      show={show}
      onHide={() => setClose(false)}>
      <Modal.Header style={{ top: 0, color: '#ffffff' }}>
        <h1 className="imgNo">{no} / 2</h1>
      </Modal.Header>
      <Modal.Body className="box h-100 flex flex-col justify-center">
        <Carousel
          disableArrowsOnEnd={false}
          enableSwipe
          showArrows={width < 1024 ? false : true}
          pagination={false}
          onChange={(currentItemObject, currentPageIndex) => {
            // console.log(currentPageIndex);
            setNo(currentPageIndex + 1);
          }}
          className="juctionCarousel">
          {items.map(item => (
            <div>
              <div key={item.id} className="flex flex-col justify-center ">
                <img src={item.imgsrc} className="img img-fluid" alt="" style={{ objectFit: 'contain' }} />
              </div>
            </div>
          ))}
          <Styles/>
        </Carousel>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}

JuctionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
};

export default JuctionModal;
